import React, { FC, useEffect } from 'react';
import { useIsMobile } from '../../../utils/getIsMobile';
import { PostProductCard } from '../PostProductCard/PostProductCard';
import { UnavailableProductCard } from '../PostProductCard/parts/UnavailableProductCard/UnavailableProductCard';
import { GridContainer } from './styles';
import { PostProductGridProps } from './types';

export const PostProductGrid: FC<PostProductGridProps> = ({
    products,
    business,
    onProductClick,
    trackProductShown,
    ...other
}) => {
    const isMobile = useIsMobile();
    const [hasShownLogged, setHasShownLogged] = React.useState(false);

    useEffect(() => {
        if (!hasShownLogged && products.length > 0) {
            products.forEach((product) => {
                trackProductShown?.(product.id, product.url);
            });
            setHasShownLogged(true);
        }
    }, [hasShownLogged, products, trackProductShown]);

    return (
        <GridContainer px={2} pb={1} width="100%" isMobile={isMobile} {...other}>
            {products.map((product) =>
                product.isUnavailable ? (
                    <UnavailableProductCard
                        key={product.id}
                        product={product}
                        business={business}
                    />
                ) : (
                    <PostProductCard
                        key={product.id}
                        product={product}
                        business={business}
                        onProductClick={onProductClick}
                    />
                ),
            )}
        </GridContainer>
    );
};
